import { Landmark, ShoppingBag } from "lucide-react";
import { useLang } from "@/i18n";
import { PHOTOS } from "@/photos";
import { FadeUp } from "./Reveal";

const CARD_STYLE = [
  { img: PHOTOS.ostia, icon: Landmark },
  { img: null, icon: ShoppingBag },
  { img: PHOTOS.rome, icon: Landmark },
];

export default function Surroundings() {
  const { t } = useLang();

  return (
    <section id="dintorni" className="bg-teal-950 py-24 sm:py-32" data-testid="surroundings-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <FadeUp>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-teal-300">{t.surroundings.eyebrow}</p>
          <h2 className="font-display mt-3 max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {t.surroundings.title}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-teal-100/70 sm:text-lg">
            {t.surroundings.subtitle}
          </p>
        </FadeUp>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {t.surroundings.items.map((item, i) => {
            const style = CARD_STYLE[i];
            const Icon = style.icon;
            const img = style.img;
            return (
              <FadeUp key={item.name} delay={i * 0.12}>
                <article className="group relative flex h-80 flex-col justify-end overflow-hidden rounded-3xl">
                  {img ? (
                    <>
                      <img
                        src={img}
                        alt={item.name}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-teal-950/90 via-teal-950/30 to-transparent" />
                    </>
                  ) : (
                    <div className="absolute inset-0 bg-gradient-to-br from-pink-600 to-pink-800" />
                  )}
                  <div className="relative flex flex-col gap-2 p-7">
                    <div className="mb-auto flex items-start justify-between">
                      <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 text-white backdrop-blur-md">
                        <Icon className="h-5 w-5" />
                      </span>
                      <span className="rounded-full bg-white/90 px-3.5 py-1.5 text-xs font-bold text-teal-900">
                        {item.dist}
                      </span>
                    </div>
                    <h3 className="font-display text-2xl font-bold text-white">{item.name}</h3>
                    <p className="text-sm text-white/75">{item.desc}</p>
                  </div>
                </article>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
